import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=115400d6"
import script from "./ItemGroup.vue?vue&type=script&lang=js"
export * from "./ItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports